/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_Guide_TitleInputs */

const en_lg_search_guide_title = /** @type {(inputs: Lg_Search_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching across conversations`)
};

const id_lg_search_guide_title = /** @type {(inputs: Lg_Search_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencari pesan lintas percakapan`)
};

/**
* | output |
* | --- |
* | "Searching across conversations" |
*
* @param {Lg_Search_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_guide_title = /** @type {((inputs?: Lg_Search_Guide_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_Guide_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_guide_title(inputs)
	return en_lg_search_guide_title(inputs)
});